export type EventType = 'flight' | 'hotel' | 'activity' | 'transport' | 'other';

export type EventStatus = 'booked' | 'planning' | 'not-booked';

export interface Event {
  id: string;
  name: string;
  type: EventType;
  status: EventStatus;
  date: Date;
  /** End date for multi-day events (e.g. stay, flight end). */
  endDate?: Date;
  location?: string;
  notes?: string;
  /** Trip this event belongs to (matches the trip name). */
  trip?: string;
  /** Extra fields per event type (e.g. confirmation #, airline, check-out date). */
  details?: Record<string, string | number | boolean>;
}

export const EVENT_TYPES: Record<
  EventType,
  {
    label: string;
    emoji: string;
  }
> = {
  flight: { label: 'Flight', emoji: '✈️' },
  hotel: { label: 'Hotel', emoji: '🏨' },
  activity: { label: 'Activity', emoji: '🎟️' },
  transport: { label: 'Transport', emoji: '🚆' },
  other: { label: 'Other', emoji: '📌' },
};

export const STATUS_CONFIG: Record<
  EventStatus,
  {
    label: string;
    color: string;
  }
> = {
  booked: { label: 'Booked', color: '#4D795F' },
  planning: { label: 'Planning', color: '#8F7036' },
  'not-booked': { label: 'Not Booked', color: '#9E5450' },
};

